
<div class="gridheight mat-elevation-z8 viewport">

    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" multiTemplateDataRows matSort>
      <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef>Actions</th>
          <td mat-cell *matCellDef="let row">
            <div>
              <button mat-icon-button type="button" class="icon-btn edit-icon" title="Edit" (click)="onOpen(row, 'Edit')">
                <mat-icon>edit</mat-icon>
              </button>
              @if(controlPermissions.deleteChemistry){
                <button mat-icon-button type="button" color="warn" title="Delete" (click)="onDelete(row.id, row.c_LabName)" style="color: red;">
                  <mat-icon>delete</mat-icon>
                </button>
              }
            </div>
          </td>
      </ng-container>
      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> ID </th>
        <td mat-cell *matCellDef="let element"> {{element.id}} </td>
      </ng-container>
      <ng-container matColumnDef="c_LabName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Lab Name </th>
        <td mat-cell *matCellDef="let element"> {{element.c_LabName}} </td>
      </ng-container>

      <ng-container matColumnDef="c_LabreportID">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Lab Report ID </th>
        <td mat-cell *matCellDef="let element"> {{ element.c_LabreportID }} </td>
      </ng-container>

      <ng-container matColumnDef="c_DateSampled">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Sample Date </th>
        <td mat-cell *matCellDef="let element"> {{ formatDate(element.c_DateSampled) }} </td>
      </ng-container>
      <ng-container matColumnDef="c_DateTested">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Test Date </th>
        <td mat-cell *matCellDef="let element"> {{ formatDate(element.c_DateTested) }} </td>
      </ng-container>
      <ng-container matColumnDef="testingTypeName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Testing Type </th>
        <td mat-cell *matCellDef="let element"> {{element.testingTypeName}} </td>
      </ng-container>
      <ng-container matColumnDef="cod">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> COD <br/>(mg/L) </th>
        <td mat-cell *matCellDef="let element"> {{element.cod}} </td>
      </ng-container>
      <ng-container matColumnDef="tvs">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> TVS <br/>(mg/kg) </th>
        <td mat-cell *matCellDef="let element"> {{element.tvs}} </td>
      </ng-container>
      <ng-container matColumnDef="ts">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> TS <br/>(mg/kg) </th>
        <td mat-cell *matCellDef="let element"> {{element.ts}} </td>
      </ng-container>
      <ng-container matColumnDef="cNratio">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> C/N Ratio </th>
        <td mat-cell *matCellDef="let element"> {{element.cNratio}} </td>
      </ng-container>
      <ng-container matColumnDef="density">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Specific <br/>Gravity </th>
        <td mat-cell *matCellDef="let element"> {{element.density}} </td>
      </ng-container>
      <ng-container matColumnDef="totalCarbon">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> TOC <br/>(mg/l) </th>
        <td mat-cell *matCellDef="let element"> {{element.totalCarbon}} </td>
      </ng-container>
      <ng-container matColumnDef="ammonia">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Ammonia <br/>(mg/l) </th>
        <td mat-cell *matCellDef="let element"> {{element.ammonia}} </td>
      </ng-container>
      <ng-container matColumnDef="tkn">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> TKN <br/>(mg/l) </th>
        <td mat-cell *matCellDef="let element"> {{element.tkn}} </td>
      </ng-container>
      <ng-container matColumnDef="totalNitrogen">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Total Nitrogen <br/>(mg/l) </th>
        <td mat-cell *matCellDef="let element"> {{element.totalNitrogen}} </td>
      </ng-container>
      <ng-container matColumnDef="totalSulfur">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Total Sulphur <br/>(mg/L) </th>
        <td mat-cell *matCellDef="let element"> {{element.totalSulfur}} </td>
      </ng-container>
      <ng-container matColumnDef="sulfides">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Sulphides <br/>(mg/L) </th>
        <td mat-cell *matCellDef="let element"> {{element.sulfides}} </td>
      </ng-container>
      <ng-container matColumnDef="phosphate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Phosphorus <br/>(mg/L) </th>
        <td mat-cell *matCellDef="let element"> {{element.phosphate}} </td>
      </ng-container>
      <ng-container matColumnDef="potassium">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Potassium <br/>(mg/L) </th>
        <td mat-cell *matCellDef="let element"> {{element.potassium}} </td>
      </ng-container>
      <ng-container matColumnDef="pH">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> PH </th>
        <td mat-cell *matCellDef="let element"> {{element.pH}} </td>
      </ng-container>
      <ng-container matColumnDef="sodium">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Sodium <br/>(mg/L) </th>
        <td mat-cell *matCellDef="let element"> {{element.sodium}} </td>
      </ng-container>
      <ng-container matColumnDef="calcium">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Calcium <br/>(mg/L) </th>
        <td mat-cell *matCellDef="let element"> {{element.calcium}} </td>
      </ng-container>
      <ng-container matColumnDef="magnesium">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Magnesium <br/>(mg/L) </th>
        <td mat-cell *matCellDef="let element"> {{element.magnesium}} </td>
      </ng-container>
      <ng-container matColumnDef="iron">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Iron <br/>(mg/L) </th>
        <td mat-cell *matCellDef="let element"> {{element.iron}} </td>
      </ng-container>
      <ng-container matColumnDef="methanol">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Methanol <br/>(mg/L) </th>
        <td mat-cell *matCellDef="let element"> {{element.methanol}} </td>
      </ng-container>
      <ng-container matColumnDef="chlorides">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Chlorides <br/>(mg/L) </th>
        <td mat-cell *matCellDef="let element"> {{element.chlorides}} </td>
      </ng-container>
      <ng-container matColumnDef="oilsAndGrease">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Oils & Grease <br/>(mg/L) </th>
        <td mat-cell *matCellDef="let element"> {{element.oilsAndGrease}} </td>
      </ng-container>
      <ng-container matColumnDef="notes">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Notes </th>
        <td mat-cell *matCellDef="let element"> {{element.notes}} </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" [attr.colspan]="displayedColumns.length"
          style="color: red;text-align: center;font-weight: 500;">
          No Chemistry data matching the filter.
        </td>
      </tr>
      <!-- <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" [attr.colspan]="displayedColumns.length"
            style="color: red;text-align: center;font-weight: 500;">
            No data matching the filter.
          </td>
        </tr> -->
    </table>
  </div>

